<mat-list class="w-20rem md:w-23rem">
  <mat-list-item
    class="item flex cursor-pointer w-auto pl-5"
    routerLink="/admin/dashboard"
    routerLinkActive="active-link">
    <div [ngStyle]="{ color: theme() && theme()[0] && theme()[0].general }">
      <mat-icon
        class="mr-3"
        [ngStyle]="{ color: theme() && theme()[0] && theme()[0].accent }"
        >home</mat-icon
      >
      Inicio
    </div>
  </mat-list-item>
  @if (role() === 'SYSADMIN') {
    <mat-list-item
      class="item flex cursor-pointer w-auto pl-5"
      routerLink="/admin/general/country"
      routerLinkActive="active-link">
      <div [ngStyle]="{ color: theme() && theme()[0] && theme()[0].general }">
        <mat-icon
          class="mr-3"
          [ngStyle]="{ color: theme() && theme()[0] && theme()[0].accent }"
          >flag_circle</mat-icon
        >
        Países
      </div>
    </mat-list-item>
  }
  @if (isOpenGeneral()) {
    <mat-list-item
      class="flex cursor-pointer w-auto pl-5"
      (click)="openGeneralElements()">
      <div [ngStyle]="{ color: theme() && theme()[0] && theme()[0].general }">
        <div [ngStyle]="{ color: theme() && theme()[0] && theme()[0].general }">
          <mat-icon
            class="mr-3"
            [ngStyle]="{ color: theme() && theme()[0] && theme()[0].accent }"
            >{{
              isOpenGeneralElements() ? 'expand_less' : 'expand_more'
            }}</mat-icon
          >
          Empresas
        </div>
      </div>
    </mat-list-item>
  }
  @if (isOpenGeneralElements()) {
    <div>
      @for (item of general; track item) {
        @if (item.show) {
          <mat-list-item
            class="pl-6 flex cursor-pointer w-auto hover:bg-black-alpha-10"
            [routerLink]="item.route"
            routerLinkActive="active-link">
            <div
              [ngStyle]="{
                color: theme() && theme()[0] && theme()[0].general
              }">
              <mat-icon
                class="mr-2"
                [ngStyle]="{
                  color: theme() && theme()[0] && theme()[0].accent
                }"
                >{{ item.icon }}</mat-icon
              >
              {{ item.label }}
            </div>
          </mat-list-item>
        }
      }
    </div>
  }
  @if (isOpenReservations()) {
    <mat-list-item
      class="flex cursor-pointer w-auto pl-5"
      (click)="openReservationsElements()">
      <div [ngStyle]="{ color: theme() && theme()[0] && theme()[0].general }">
        <mat-icon
          class="mr-3"
          [ngStyle]="{ color: theme() && theme()[0] && theme()[0].accent }"
          >{{
            isOpenReservationsElements() ? 'expand_less' : 'expand_more'
          }}</mat-icon
        >
        Reservaciones
      </div>
    </mat-list-item>
  }
  @if (isOpenReservationsElements()) {
    <div>
      @for (item of reservations; track item) {
        @if (item.show) {
          <mat-list-item
            class="pl-6 flex cursor-pointer w-auto hover:bg-black-alpha-10"
            [routerLink]="item.route"
            routerLinkActive="active-link">
            <div
              [ngStyle]="{
                color: theme() && theme()[0] && theme()[0].general
              }">
              <mat-icon
                class="mr-2"
                [ngStyle]="{
                  color: theme() && theme()[0] && theme()[0].accent
                }"
                >{{ item.icon }}</mat-icon
              >
              {{ item.label }}
            </div>
          </mat-list-item>
        }
      }
    </div>
  }
  @if (isOpenGroups()) {
    <mat-list-item
      class="flex cursor-pointer w-auto pl-5"
      (click)="openGroupsElements()">
      <div [ngStyle]="{ color: theme() && theme()[0] && theme()[0].general }">
        <mat-icon
          class="mr-3"
          [ngStyle]="{ color: theme() && theme()[0] && theme()[0].accent }"
          >{{
            isOpenGroupsElements() ? 'expand_less' : 'expand_more'
          }}</mat-icon
        >
        Grupos
      </div>
    </mat-list-item>
  }
  @if (isOpenGroupsElements()) {
    <div>
      @for (item of groups; track item) {
        @if (item.show) {
          <mat-list-item
            class="pl-6 flex cursor-pointer w-auto hover:bg-black-alpha-10"
            [routerLink]="item.route"
            routerLinkActive="active-link">
            <div
              [ngStyle]="{
                color: theme() && theme()[0] && theme()[0].general
              }">
              <mat-icon
                class="mr-2"
                [ngStyle]="{
                  color: theme() && theme()[0] && theme()[0].accent
                }"
                >{{ item.icon }}</mat-icon
              >
              {{ item.label }}
            </div>
          </mat-list-item>
        }
      }
    </div>
  }
  @if (isOpenReports()) {
    <mat-list-item
      class="flex cursor-pointer w-auto pl-5"
      (click)="openReportsElements()">
      <div [ngStyle]="{ color: theme() && theme()[0] && theme()[0].general }">
        <mat-icon
          class="mr-3"
          [ngStyle]="{ color: theme() && theme()[0] && theme()[0].accent }"
          >{{
            isOpenReportsElements() ? 'expand_less' : 'expand_more'
          }}</mat-icon
        >
        Reportes
      </div>
    </mat-list-item>
  }
  @if (isOpenReportsElements()) {
    <div>
      @for (item of reports; track item) {
        @if (item.show) {
          <mat-list-item
            class="pl-6 flex cursor-pointer w-auto hover:bg-black-alpha-10"
            [routerLink]="item.route"
            routerLinkActive="active-link">
            <div
              [ngStyle]="{
                color: theme() && theme()[0] && theme()[0].general
              }">
              <mat-icon
                class="mr-2"
                [ngStyle]="{
                  color: theme() && theme()[0] && theme()[0].accent
                }"
                >{{ item.icon }}</mat-icon
              >
              {{ item.label }}
            </div>
          </mat-list-item>
        }
      }
    </div>
  }
  @if (isOpenBlacklist()) {
    <mat-list-item
      class="flex cursor-pointer w-auto pl-5"
      (click)="openBlacklistElements()">
      <div [ngStyle]="{ color: theme() && theme()[0] && theme()[0].general }">
        <mat-icon
          class="mr-3"
          [ngStyle]="{ color: theme() && theme()[0] && theme()[0].accent }"
          >{{
            isOpenBlacklistElements() ? 'expand_less' : 'expand_more'
          }}</mat-icon
        >
        Lista Negra
      </div>
    </mat-list-item>
  }
  @if (isOpenBlacklistElements()) {
    <div>
      @for (item of blacklist; track item) {
        @if (item.show) {
          <mat-list-item
            class="pl-6 flex cursor-pointer w-auto hover:bg-black-alpha-10"
            [routerLink]="item.route"
            routerLinkActive="active-link">
            <div
              [ngStyle]="{
                color: theme() && theme()[0] && theme()[0].general
              }">
              <mat-icon
                class="mr-2"
                [ngStyle]="{
                  color: theme() && theme()[0] && theme()[0].accent
                }"
                >{{ item.icon }}</mat-icon
              >
              {{ item.label }}
            </div>
          </mat-list-item>
        }
      }
    </div>
  }
  @if (isOpenTools()) {
    <mat-list-item
      class="flex cursor-pointer w-auto pl-5"
      (click)="openToolsElements()">
      <div [ngStyle]="{ color: theme() && theme()[0] && theme()[0].general }">
        <mat-icon
          class="mr-3"
          [ngStyle]="{ color: theme() && theme()[0] && theme()[0].accent }"
          >{{ isOpenToolsElements() ? 'expand_less' : 'expand_more' }}</mat-icon
        >
        Configuración
      </div>
    </mat-list-item>
  }
  @if (isOpenToolsElements()) {
    <div>
      @for (item of tools; track item) {
        @if (item.show) {
          <mat-list-item
            class="pl-6 flex cursor-pointer w-auto hover:bg-black-alpha-10"
            [routerLink]="item.route"
            routerLinkActive="active-link">
            <div
              [ngStyle]="{
                color: theme() && theme()[0] && theme()[0].general
              }">
              <mat-icon
                class="mr-2"
                [ngStyle]="{
                  color: theme() && theme()[0] && theme()[0].accent
                }"
                >{{ item.icon }}</mat-icon
              >
              {{ item.label }}
            </div>
          </mat-list-item>
        }
      }
    </div>
  }
</mat-list>
